import { Datetime, Field, Select } from "components/shared/form";
import { formatDateForDocumentTag } from "helpers/date";
import { requiredField } from "helpers/validators";
import moment from "moment";
import React, { useState } from "react";
import { alert } from "services/alert";
import { singleList as classificationTypesSingleList } from "sources/books/classificationTypes";
import WithoutSigningFilesInfo from "./withoutSigningFilesInfo";

function ClassificationType(props) {
    const [loading, setLoading] = useState(false);
    const [classificationType, setClassificationType] = useState(props.classificationType);

    const apply = () => {
        setLoading(true);
        props.applyClassificationType(classificationType).then(() => {
            props.back();
        });
    };

    return (
        <div className={loading ? "loading" : ""}>
            <textarea
                className="form-control form-control-sm mb-3"
                rows={10}
                value={classificationType}
                onChange={(e) => setClassificationType(e.target.value)}
            />
            <div className="btn btn-brand btn-block" onClick={apply}>
                Создать
            </div>
        </div>
    );
}

export default function CreateByClassification(props) {
    const [loading, setLoading] = useState(false);
    const [classificationTypeId, setClassificationTypeId] = useState(false);
    const [documentDate, setDocumentDate] = useState(() => moment().format("YYYY-MM-DD"));
    const [manualValues, setManualValues] = useState({});
    const handleCreate = ({ withoutSigningFiles = false } = {}) => {
        if (!classificationTypeId) {
            return alert({ type: "warning", message: "Выберите тип номенклатуры", title: "Ошибка" });
        }
        setLoading(true);

        props.previewAction({ classificationTypeId, id: props.id }).then((res) => {
            props.add({
                name: "default",
                title: "Номенклатура",
                windowMod: "sm",
                CustomBody: ClassificationType,
                onCloseAction: () => setLoading(false),
                bodyData: {
                    classificationType: res.classificationType,
                    applyClassificationType: (classificationType) => {
                        const formattedManualValues = {
                            documentDate: formatDateForDocumentTag(documentDate),
                            ...(props.manualValues?.reduce((acc, item) => {
                                const { name, type } = item.inputProps;
                                if (!manualValues[name]) {
                                    return acc;
                                }
                                acc[name] =
                                    type === "date" ? formatDateForDocumentTag(manualValues[name]) : manualValues[name];
                                return acc;
                            }, {}) || {}),
                        };
                        return props
                            .action({
                                id: props.id,
                                classificationTypeId,
                                classificationType,
                                manualValues: formattedManualValues,
                                ...(withoutSigningFiles ? { withoutSigningFiles } : {}),
                            })
                            .then((res) => {
                                if (res) {
                                    props.back();
                                } else {
                                    setLoading(false);
                                }
                            })
                            .catch(() => {
                                setLoading(false);
                            });
                    },
                },
            });
        });
    };
    const selectProps = {
        inputProps: { name: "classificationTypeId" },
        label: "Тип номенклатуры",
        value: classificationTypeId,
        placeholder: "Выберите тип номенклатуры",
        url: classificationTypesSingleList,
        propName: "name",
        onChange: ({ value }) => setClassificationTypeId(value),
        menuPortalTarget: document.body,
        required: true,
        validators: [requiredField],
        labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
        fieldWrapper: "col-12",
    };
    return (
        <div className={loading ? "loading loading--small" : ""}>
            <div className="card card-body mb-3">
                <h5>Основные параметры</h5>
                <Select {...selectProps} />
            </div>
            {props.documentDate && (
                <div className="card card-body mb-3">
                    <h5>Параметры документа</h5>
                    <Datetime
                        labelWrapper="col-12 col-form-label col-form-label-sm text-muted"
                        wrapper="col-12"
                        inPortal
                        {...props.documentDate}
                        value={documentDate}
                        onChange={({ value }) => setDocumentDate(value)}
                    />
                </div>
            )}
            {!!props.manualValues?.length && (
                <div className="card card-body mb-3">
                    <h5>Основание для выставления документа</h5>
                    <small className="text-muted pb-2">
                        Если документ выставляется на основании договора, акта или другого документа, укажите его номер
                        и дату. Эти данные будут отражены в документе.
                    </small>
                    {props.manualValues?.map((item) =>
                        item.type === "date" ? (
                            <Datetime
                                labelWrapper="col-12 col-form-label col-form-label-sm text-muted"
                                wrapper="col-12"
                                inPortal
                                key={item.inputProps.name}
                                {...item}
                                value={manualValues[item.inputProps.name]}
                                onChange={({ name, value }) => setManualValues({ ...manualValues, [name]: value })}
                            />
                        ) : (
                            <Field
                                labelWrapper="col-12 col-form-label col-form-label-sm text-muted"
                                fieldWrapper="col-12"
                                key={item.inputProps.name}
                                {...item}
                                value={manualValues[item.inputProps.name]}
                                onChange={({ name, value }) => setManualValues({ ...manualValues, [name]: value })}
                            />
                        ),
                    )}
                </div>
            )}
            <WithoutSigningFilesInfo />
            <div className="btn btn-sm btn-brand btn-block" onClick={() => handleCreate()}>
                Создать документ
            </div>
            <div
                className="btn btn-sm btn-outline-primary btn-block"
                onClick={() => handleCreate({ withoutSigningFiles: true })}
            >
                Создать документ без печати и подписи
            </div>
        </div>
    );
}
